export default {
  locale: "en",
  name: "Forwarding reservations to channels",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "hotelTicker",
        displayName: "Hotel Ticker",
        description: "",
        helpText: "",
        placeholder: "Enter a hotel ticker",
      },
      {
        fieldName: "reservationId",
        displayName: "Reservation Id (M)",
        description: "Identifier of reservation",
        helpText: "",
        placeholder: "Enter a reservation id",
      },
    ],
  },
};
